/* eslint-disable import/prefer-default-export */
export const GET_BASESTATIONS_LIST_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
